import { render, staticRenderFns } from "./PublicEventTab.vue?vue&type=template&id=007f31c7&lang=pug"
import script from "./PublicEventTab.vue?vue&type=script&lang=ts"
export * from "./PublicEventTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports